export default __webpack_public_path__ + "static/media/Close.cd8d7372.svg";